import { DEFAULT_DOWN_IMG, DEFAULT_NO_IMG, DEFAULT_UP_IMG, DEFAULT_YSE_IMG } from '../confs/app';
// Type-only import keeps `marked` (the 'markdown' manual chunk) out of the
// static/eager import graph — the runtime module is dynamically imported
// below, only when readerMarkdown actually runs.
import type { MarkedOptions, Tokens } from 'marked';

export const readerMarkdown = async (
  markdown: string,
  options?: MarkedOptions | null
): Promise<[Tokens.Image[], string]> => {
  const images: Tokens.Image[] = [];
  const imgRegex = /<img\s+[^>]*src\s*=\s*["']([^"']+)["'][^>]*>/gi;
  let match;
  while ((match = imgRegex.exec(markdown)) !== null) {
    const href = match[1];
    const imgToken = {
      type: 'image',
      raw: match[0],
      href: href,
      title: '',
      text: '',
    } as Tokens.Image;
    const altMatch = match[0].match(/alt\s*=\s*["']([^"']*)["']/i);
    if (altMatch) {
      imgToken.text = altMatch[1];
    }
    const titleMatch = match[0].match(/title\s*=\s*["']([^"']*)["']/i);
    if (titleMatch) {
      imgToken.title = titleMatch[1];
    }
    images.push(imgToken);
  }
  const renderer = {
    image(img: Tokens.Image) {
      images.push(img);
      return `<img src="${img.href}" title=${img.title} alt=${img.text} rel="noopener noreferrer"/>`;
    },
    link({ href, text }: Tokens.Link) {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    },
    html({ text }: Tokens.HTML | Tokens.Tag) {
      return text.replace(/\s+style\s*=\s*["'][^"']*["']/gi, '').replace(/\s+class\s*=\s*["'][^"']*["']/gi, '');
    },
  };
  const { marked } = await import('marked');
  const markdownHtml = await marked.use({ renderer }).parse(markdown, options);
  const img = images.filter(img => img.href.startsWith('https://'));
  return [img, markdownHtml];
};

export const extractImages = async (markdown: string, count: number = 4): Promise<string[]> => {
  const [images] = await readerMarkdown(markdown);
  return images.slice(0, count).map(img => img.href);
};

export const getDefaultImg = (description: string) => {
  switch (description.toLowerCase()) {
    case 'yes':
      return DEFAULT_YSE_IMG;
    case 'no':
      return DEFAULT_NO_IMG;
    case 'up':
      return DEFAULT_UP_IMG;
    case 'down':
      return DEFAULT_DOWN_IMG;
    default:
      return undefined;
  }
};
